// const config = {
//     apiKey: "AIzaSyA9quHvOcZIpy-VvLA7jc6ZxCLWOEloBOE",
//     authDomain: "souvenirsofconflict.firebaseapp.com",
//     databaseURL: "https://souvenirsofconflict.firebaseio.com",
//     projectId: "souvenirsofconflict",
//     storageBucket: "souvenirsofconflict.appspot.com",
//     messagingSenderId: "528479876028"

// };

const config = {
    apiKey: "AIzaSyAuh4ibW9k2MGXHbhU1Y6OwNm4KZPGVgdM",
    authDomain: "souvenirsofconflict-dc713.firebaseapp.com",
    databaseURL: "https://souvenirsofconflict-dc713.firebaseio.com",
    projectId: "souvenirsofconflict-dc713",
    storageBucket: "souvenirsofconflict-dc713.appspot.com",
    messagingSenderId: "1022675670275",
    appId: "1:1022675670275:web:6d624a18f4772df1"
}

export default config;